import styled from 'styled-components'

export const Container = styled.div`
background: #F2DBD8;
height: 100vh;

display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
`